import { render } from "./MenuTabs.vue?vue&type=template&id=34fd30de&scoped=true"
import script from "./MenuTabs.vue?vue&type=script&lang=js"
export * from "./MenuTabs.vue?vue&type=script&lang=js"

import "./MenuTabs.vue?vue&type=style&index=0&id=34fd30de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fd30de"]])

export default __exports__